import * as z from "zod/v4";

export const getProductTitles = {
  name: "getProductTitles" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(z.string()),
};
